import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { IdleService } from 'gaming-component-ngx-common';
// import * as jQuery from 'jquery';
declare var jQuery: any;

@Component({
  selector: "app-maxsys",
  templateUrl: "./app.component.html",
})
export class AppComponent implements OnInit {
  public constructor(private titleService: Title, private router: Router, private route: ActivatedRoute, private idleService: IdleService) {
    router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        let title = this.getTitle(router.routerState, router.routerState.root).join(" ").replace(/,\s*$/, "");
        titleService.setTitle(title);
      }
    });
   }

  public getTitle(state, parent) {
    let data = [];
    if (parent && parent.snapshot.data && parent.snapshot.data.title) {
      data.push(parent.snapshot.data.title);
    }

    if (state && parent) {
      data.push(this.getTitle(state, state.firstChild(parent)));
    }
    return data;
  }

  public ngOnInit() {
    // 60 secs of no activity = idle then after 20 minutes of further inactivity the user is logged out.
    this.idleService.setupIdle(60, 1200);
  }
}


// WEBPACK FOOTER //
// ./client/app/app.component.ts